__cw__define(['domReady!', 'require', 'jquery'], function (domReady, require, $) {
  //Gestion de la bordure bleu en navigation clavier - Mobile
  $('body').on('focus', '.dropdown-menu-large .mega-menu-content a', function () {
    $(this).addClass('nav-mfocus');
  });
  $('body').on('blur', '.dropdown-menu-large .mega-menu-content a', function () {
    $(this).removeClass('nav-mfocus');
  });
  $('body').on('mouseenter', '.dropdown-menu-large .mega-menu-content a', function () {
    $('.dropdown-menu-large .mega-menu-content a').removeClass('nav-mfocus');
  });
  $('body').on('mouseleave', '.dropdown-menu-large .mega-menu-content a', function () {
    $(':focus').addClass('nav-mfocus');
  });

  //Gestion de la bordure bleu en navigation clavier - Tablet/Desktop
  $('body').on('focus', '.dropdown-toggle', function () {
    $(this).parent('.dropdown').addClass('nav-focus');
  });
  $('body').on('blur', '.dropdown-toggle', function () {
    $(this).parent('.dropdown').removeClass('nav-focus');
  });
  $('body').on('mouseenter', '.dropdown-toggle', function () {
    $(this).parent().siblings('.dropdown').removeClass('nav-focus');
  });
  $('body').on('mouseleave', '.dropdown-toggle', function () {
    $(':focus').parent('.dropdown').addClass('nav-focus');
  });

  // Ne pas fermer le menu si on clique sur un élément enfant du dropdown
  $('.dropdown-menu').click(function () {
    $(this).parent().addClass('prevent-close');
  });
  $('.dropdown').on('hide.bs.dropdown', function (e) {
    if ($(this).hasClass('prevent-close')) {
      e.preventDefault();
      $(this).removeClass('prevent-close');
    }
  });
  $('.dropdown').on('hide.bs.dropdown', function (e) {
    if ($(this).hasClass('prevent-close')) {
      e.preventDefault();
      $(this).removeClass('prevent-close');
    }
  });
});